import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const isProd = process.env.NODE_ENV === 'production';
const renderMethod = isProd ? ReactDOM.hydrate : ReactDOM.render;

renderMethod(<App />, document.getElementById('app'));
